import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

const RECEIPT_PARAM = 'receipt'

export function ReceiptDrawer() {
  const [searchParams, setSearchParams] = useSearchParams()
  const receiptId = searchParams.get(RECEIPT_PARAM)

  useEffect(() => {
    if (!receiptId) return
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev)
        next.delete(RECEIPT_PARAM)
        return next
      },
      { replace: true },
    )
  }, [receiptId, setSearchParams])

  return null
}
